import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getFirestore, collection, query, where, orderBy, limit, getDocs, Timestamp } from "firebase/firestore";
import { fetchLiveBankBalances, formatTry as formatBankTry } from "../utils/bankBalanceCheck";
import { getAuth } from "firebase/auth";

const MevcutKasa = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sube = queryParams.get("sube")?.trim();
  
  // State'ler
  const [kasaData, setKasaData] = useState({});
  const [bankaBakiyesi, setBankaBakiyesi] = useState(0); 
  // Bankadaki gercek bakiye: kasadaki rakamla uyumlu mu, kartin altinda gorunur.
  const [canliBanka, setCanliBanka] = useState(null);
  const [krediKartiBakiyesi, setKrediKartiBakiyesi] = useState(0);
  const [nakitKasa, setNakitKasa] = useState(0); 
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  
  const navigate = useNavigate();
  const db = getFirestore();
  const auth = getAuth();

  // KATEGORİLER
  const categories = [
    {
      key: "sarrafiye",
      name: "Sarrafiye",
      field: "adet",
      fieldLabel: "Adet",
      items: [
        { key: "eskiZiynetCeyrek", label: "Eski Ziynet Çeyrek" },
        { key: "yeniZiynetCeyrek", label: "Yeni Ziynet Çeyrek" },
        { key: "eskiZiynetYarim", label: "Eski Ziynet Yarım" },
        { key: "yeniZiynetYarim", label: "Yeni Ziynet Yarım" },
        { key: "eskiZiynetTam", label: "Eski Ziynet Tam" },
        { key: "yeniZiynetTam", label: "Yeni Ziynet Tam" },
        { key: "eskiZiynetGremse", label: "Eski Ziynet 2.5'lu Gremse" },
        { key: "yeniZiynetGremse", label: "Yeni Ziynet 2.5'lu Gremse" },
        { key: "eskiZiynetBesli", label: "Eski Ziynet Beşli" },
        { key: "yeniZiynetBesli", label: "Yeni Ziynet Beşli" },
        { key: "cumhuriyetAtaCeyrek", label: "Cumhuriyet Ata Çeyrek" },
        { key: "cumhuriyetAtaYarim", label: "Cumhuriyet Ata Yarım" },
        { key: "cumhuriyetAta", label: "Cumhuriyet Ata" },
        { key: "cumhuriyetAtaGremse", label: "Cumhuriyet Ata 2.5'lu Gremse" },
        { key: "cumhuriyetAtaBesli", label: "Cumhuriyet Ata Beşli" },
        { key: "resatCeyrek", label: "Reşat Çeyrek" },
        { key: "resatYarim", label: "Reşat Yarım" },
        { key: "resat", label: "Reşat" },
        { key: "resatGremse", label: "Reşat 2.5'lu Gremse" },
        { key: "resatBesli", label: "Reşat Beşli" }
      ]
    },
    {
      key: "gramAltin",
      name: "Gram Altın",
      field: "adet",
      fieldLabel: "Adet",
      items: [
        { key: "birGram22Ayar", label: "1 Gram 22 Ayar" },
        { key: "yariGram22Ayar", label: "0.50 Gram 22 Ayar" },
        { key: "ceyrekGram22Ayar", label: "0.25 Gram 22 Ayar" },
        { key: "birGram24Ayar", label: "1 Gram 24 Ayar" },
        { key: "yariGram24Ayar", label: "0.50 Gram 24 Ayar" },
        { key: "ceyrekGram24Ayar", label: "0.25 Gram 24 Ayar" },
        { key: "ikiBucukGram24Ayar", label: "2.50 Gram 24 Ayar" },
        { key: "besGram24Ayar", label: "5 Gram 24 Ayar" },
        { key: "onGram24Ayar", label: "10 Gram 24 Ayar" },
        { key: "yirmiGram24Ayar", label: "20 Gram 24 Ayar" },
        { key: "elliGram24Ayar", label: "50 Gram 24 Ayar" },
        { key: "yuzGram24Ayar", label: "100 Gram 24 Ayar" }
      ]
    },
    {
      key: "hurda",
      name: "Hurda",
      field: "gram",
      fieldLabel: "Gram",
      items: [
        { key: "yirmiDortAyarHurda", label: "24 Ayar Hurda" },
        { key: "yirmiIkiAyarBilezikHurda", label: "22 Ayar Bilezik Hurda" },
        { key: "yirmiIkiAyarHurda", label: "22 Ayar Hurda" },
        { key: "yirmiBirAyarHurda", label: "21 Ayar Hurda" },
        { key: "onSekizAyarHurda", label: "18 Ayar Hurda" },
        { key: "onDortAyarHurda", label: "14 Ayar Hurda" },
        { key: "sekizAyarHurda", label: "8 Ayar Hurda" }
      ]
    },
    {
      key: "doviz",
      name: "Döviz",
      field: "adet",
      fieldLabel: "Birim",
      items: [
        { key: "tl", label: "TL - Türk Lirası" },
        { key: "usd", label: "USD - Amerikan Doları" },
        { key: "eur", label: "EUR - Euro" },
        { key: "gbp", label: "GBP - İngiliz Sterlini" },
        { key: "chf", label: "CHF - İsviçre Frangı" },
        { key: "aud", label: "AUD - Avustralya Doları" },
        { key: "cad", label: "CAD - Kanada Doları" },
        { key: "sar", label: "SAR - Suudi Arabistan Riyali" },
        { key: "aed", label: "AED - Birleşik Arap Emirlikleri Dirhemi" },
        { key: "qar", label: "QAR - Katar Riyali" },
        { key: "mad", label: "MAD - Fas Dirhemi" },
        { key: "jod", label: "JOD - Ürdün Dinarı" },
        { key: "kwd", label: "KWD - Kuveyt Dinarı" },
        { key: "cny", label: "CNY - Çin Yuanı" },
        { key: "rub", label: "RUB - Rus Rublesi" },
        { key: "bgn", label: "BGN - Bulgar Levası" }
      ]
    }
  ];

  const normalizeString = (str) => {
    return str ? str.trim().toLocaleLowerCase('tr-TR').replace(/\s+/g, " ") : "";
  };

  useEffect(() => {
    const fetchKasaAndBanka = async () => {
      if (!sube) {
        setError("Şube bilgisi eksik.");
        setLoading(false);
        navigate("/subesecimi");
        return;
      }

      try {
        setLoading(true);

        // --- 1. BANKA BAKİYESİ HESAPLAMA ---
        const bankaQuery = query(
          collection(db, 'subeler', sube, 'islemler'),
          where('havaleEft', '>', 0)
        );
        const bankaSnapshot = await getDocs(bankaQuery);
        let totalBank = 0;
        
        bankaSnapshot.docs.forEach(doc => {
          const data = doc.data();
          const miktar = parseFloat(data.havaleEft) || 0;
          if (['Satış', 'Giriş'].includes(data.islemTuru)) {
            totalBank += miktar;
          } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(data.islemTuru)) {
            totalBank -= miktar;
          }
        });
        setBankaBakiyesi(totalBank);

        // Canli bakiye ayri okunur; okunamazsa kart eskisi gibi calisir.
        fetchLiveBankBalances(sube)
          .then((live) => setCanliBanka(live?.ok && live.total != null ? live : null))
          .catch(() => setCanliBanka(null));

        // --- 1.1 KREDİ KARTI BAKİYESİ HESAPLAMA ---
        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);
        const tomorrowStart = new Date(todayStart);
        tomorrowStart.setDate(tomorrowStart.getDate() + 1);

        const krediKartiQuery = query(
          collection(db, 'subeler', sube, 'islemler'),
          where('timestamp', '>=', Timestamp.fromDate(todayStart)),
          where('timestamp', '<', Timestamp.fromDate(tomorrowStart)),
          orderBy('timestamp', 'asc')
        );
        const krediKartiSnapshot = await getDocs(krediKartiQuery);
        let totalKrediKarti = 0;

        krediKartiSnapshot.docs.forEach(doc => {
          const data = doc.data();
          const miktar = parseFloat(data.krediKarti) || 0;
          if (miktar <= 0) return;
          if (['Satış', 'Giriş'].includes(data.islemTuru)) {
            totalKrediKarti += miktar;
          } else if (['Alış', 'Çıkış', 'İade', 'Değişim'].includes(data.islemTuru)) {
            totalKrediKarti -= miktar;
          }
        });
        setKrediKartiBakiyesi(totalKrediKarti);

        // --- 2. MEVCUT KASA STOK HESAPLAMA ---
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const gunsonuQuery = query(
          collection(db, "subeler", sube, "gunsonukasa"),
          where("timestamp", "<", Timestamp.fromDate(today)),
          orderBy("timestamp", "desc"),
          limit(1)
        );
        const gunsonuSnapshot = await getDocs(gunsonuQuery);
        let dunkuKapanis = {};
        if (!gunsonuSnapshot.empty) {
          dunkuKapanis = gunsonuSnapshot.docs[0].data();
        }

        const lastGunsonuTimestamp = dunkuKapanis.timestamp || new Timestamp(0, 0);
        const islemQuery = query(
          collection(db, "subeler", sube, "islemler"),
          where("timestamp", ">=", lastGunsonuTimestamp),
          orderBy("timestamp", "asc")
        );
        const querySnapshot = await getDocs(islemQuery);
        const islemler = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          timestamp: doc.data().timestamp instanceof Timestamp ? doc.data().timestamp.toDate().toISOString() : doc.data().timestamp,
        }));

        const kasa = {};
        // Yapıyı Kur
        categories.forEach((category) => {
          kasa[category.key] = {};
          category.items.forEach((item) => {
            kasa[category.key][item.key] = { adet: 0, gram: 0 };
          });
        });

        // Dünkü kapanışı yükle
        categories.forEach((category) => {
          if (dunkuKapanis[category.key]) {
            category.items.forEach((item) => {
              const dunkuAdet = dunkuKapanis[category.key]?.[item.key]?.adet || 0;
              const dunkuGram = dunkuKapanis[category.key]?.[item.key]?.gram || 0;
              kasa[category.key][item.key] = { adet: Number(dunkuAdet), gram: Number(dunkuGram) };
            });
          }
        });

        // İşlemleri İşle
        islemler.forEach((islem) => {
          const islemUrun = normalizeString(islem.urun);
          const islemKategori = normalizeString(islem.kategori);
          const gramMiktar = parseFloat(islem.gram) || 0;
          const adetMiktar = parseInt(islem.adet) || 0;
          const nakitMiktar = parseFloat(islem.nakit) || 0;
          const isTL = islem.kategori === "Döviz" && islem.urun === "TL - Türk Lirası";

          // --- 1. NAKİT İŞLEMLERİ (HER ZAMAN İŞLE, TESLİMAT DURUMU FARK ETMEZ) ---
          if (nakitMiktar > 0) {
             if (!kasa.doviz) kasa.doviz = {};
             if (!kasa.doviz.tl) kasa.doviz.tl = { adet: 0, gram: 0 };

             if (["Satış", "Çıkış"].includes(islem.islemTuru)) {
                if (isTL) kasa.doviz.tl.adet -= nakitMiktar;
                else kasa.doviz.tl.adet += nakitMiktar; // Satış yapınca para kasaya girer
             } else if (["Alış", "İade", "Değişim", "Giriş"].includes(islem.islemTuru)) {
                if (isTL) kasa.doviz.tl.adet += nakitMiktar;
                else kasa.doviz.tl.adet -= nakitMiktar; // Alış yapınca para kasadan çıkar
             }
          }

          // --- 2. STOK İŞLEMLERİ (KRİTİK GÜNCELLEME: TESLİMAT BEKLİYORSA DÜŞME) ---
          
          // Eğer işlem "Teslimat Bekliyor" ise ve türü "Satış" veya "Çıkış" ise, STOKTAN DÜŞME.
          // Çünkü ürün hala kasada duruyor.
          // Ancak, "Alış" işlemi "Teslimat Bekliyor" olmaz (müşteri getirir, alırız), bu yüzden alışları her zaman işleriz.
          
          const stokEtkilenmeli = !(islem.teslimatDurumu === "Teslimat Bekliyor" && ["Satış", "Çıkış"].includes(islem.islemTuru));

          if (stokEtkilenmeli) {
              categories.forEach((category) => {
                const categoryName = normalizeString(category.name);
                if (islemKategori === categoryName) {
                  category.items.forEach((item) => {
                    const itemLabel = normalizeString(item.label);
                    if (islemUrun === itemLabel) {
                      if (item.key === "tl") return; 

                      if (["Alış", "İade", "Değişim", "Giriş"].includes(islem.islemTuru)) {
                        if (category.key === "sarrafiye" || category.key === "gramAltin") {
                          kasa[category.key][item.key].adet += adetMiktar;
                        } else if (category.key === "hurda") {
                          kasa[category.key][item.key].gram += gramMiktar;
                        } else if (category.key === "doviz") {
                          kasa[category.key][item.key].adet += adetMiktar;
                        }
                      } else if (["Satış", "Çıkış"].includes(islem.islemTuru)) {
                        if (category.key === "sarrafiye" || category.key === "gramAltin") {
                          kasa[category.key][item.key].adet -= adetMiktar;
                        } else if (category.key === "hurda") {
                          kasa[category.key][item.key].gram -= gramMiktar;
                        } else if (category.key === "doviz") {
                          kasa[category.key][item.key].adet -= adetMiktar;
                        }
                      }
                      
                      if (category.key === "hurda") {
                        kasa[category.key][item.key].gram = Number(kasa[category.key][item.key].gram.toFixed(2));
                      }
                      if (category.key === "doviz") {
                        kasa[category.key][item.key].adet = Number(kasa[category.key][item.key].adet.toFixed(2));
                      }
                    }
                  });
                }
              });
          }
        });

        // HESAPLAMA BİTTİ, STATE GÜNCELLE
        setKasaData(kasa);
        
        // Nakit Kasa Tutarını Çek (TL)
        const currentNakit = kasa.doviz?.tl?.adet || 0;
        setNakitKasa(currentNakit);

        setLoading(false);
      } catch (err) {
        console.error("Hata:", err);
        setError(`Hata: ${err.message}`);
        setLoading(false);
      }
    };

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (!user) {
        navigate("/login");
      } else {
        fetchKasaAndBanka();
      }
    });

    return () => unsubscribe();
  }, [sube, navigate, auth]);

  if (loading) return <div style={{display:'flex', justifyContent:'center', marginTop:'50px'}}>Yükleniyor...</div>;
  if (error) return <div style={{color:'red', textAlign:'center', marginTop:'50px'}}>{error}</div>;

  const categoryLayout = {
    sarrafiye: { productWidth: "275px", totalWidth: "350px" },
    gramAltin: { productWidth: "195px", totalWidth: "270px" },
    hurda: { productWidth: "215px", totalWidth: "285px" },
    doviz: { productWidth: "335px", totalWidth: "415px" },
  };

  return (
    <div className="mk-page" style={{
      background: "linear-gradient(180deg, #f8fafd 0%, #eff3f8 100%)",
      borderRadius: "12px",
      padding: "8px 10px 10px",
      boxShadow: "0 10px 24px rgba(15, 23, 42, 0.10)",
      border: "1px solid #d9e2ee",
      width: "1580px",
      height: "735px",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
      fontFamily: "'Roboto', sans-serif",
      margin: "-10px 0 4px 0",
      position: "relative",
      overflow: "hidden",
    }}>
      <div
        className="mk-header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          margin: "0 4px 6px",
          padding: "4px 8px",
          borderBottom: "1px solid #dbe4ef",
        }}
      >
        <h2 className="mk-title" style={{ margin: 0, fontSize: "18px", fontWeight: 800, color: "#1e293b", letterSpacing: "0.2px" }}>
          Mevcut kasa
        </h2>
        <span className="mk-date" style={{ fontSize: "13px", color: "#64748b", fontWeight: 700 }}>
          {new Date().toLocaleDateString("tr-TR", { day: "2-digit", month: "long", year: "numeric", weekday: "long" })}
        </span>
      </div>

      <div className="mk-main-wrap" style={{
        display: "flex",
        flexDirection: "row-reverse",
        alignItems: "flex-start",
        gap: "10px",
        flex: 1,
        minHeight: 0,
      }}>
        <div className="mk-sidebar" style={{
          width: "235px",
          background: "linear-gradient(180deg, #fffdf4 0%, #faf5e8 100%)",
          border: "1px solid #e4dac4",
          borderRadius: "8px",
          boxShadow: "0 4px 10px rgba(15, 23, 42, 0.06)",
          padding: "8px",
          flexShrink: 0,
        }}>
          <div className="mk-sidebar-branch" style={{ fontSize: "13px", fontWeight: 800, color: "#1f2937" }}>
            {sube ? sube.toUpperCase().replace("_", " ") : "ŞUBE"}
          </div>
          <div style={{ fontSize: "10px", color: "#64748b", fontWeight: 700, marginBottom: "8px" }}>
            Mevcut kasa
          </div>
          <div className="mk-summary-grid" style={{ display: "grid", gap: "6px" }}>
            <div className="mk-summary-card" style={{ border: "1px solid #bff0d8", borderLeft: "6px solid #059669", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #06b27a 0%, #059669 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "24px", boxShadow: "0 6px 14px rgba(5,150,105,0.35)" }}>₺</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>NAKİT</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {nakitKasa.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
            <div className="mk-summary-card" style={{ border: "1px solid #dbe7ff", borderLeft: "6px solid #2563eb", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "20px", boxShadow: "0 6px 14px rgba(37,99,235,0.3)" }}>🏦</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>BANKA</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {bankaBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
                {canliBanka ? (
                  Math.abs(canliBanka.total - bankaBakiyesi) < 0.01 ? (
                    <div className="mk-bank-sync" style={{ fontSize: "11.5px", color: "#15803d", fontWeight: 700, marginTop: "3px" }}>
                      ✓ Bankayla uyumlu
                    </div>
                  ) : (
                    <div className="mk-bank-sync" style={{ fontSize: "11.5px", color: "#b91c1c", fontWeight: 700, marginTop: "3px" }}>
                      ⚠ Bankada {formatBankTry(canliBanka.total)}
                    </div>
                  )
                ) : null}
              </div>
            </div>
            <div className="mk-summary-card" style={{ border: "1px solid #ffd7bf", borderLeft: "6px solid #ea580c", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "20px", boxShadow: "0 6px 14px rgba(234,88,12,0.3)" }}>▭</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>KREDİ KARTI</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {krediKartiBakiyesi.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
            <div className="mk-summary-card" style={{ border: "1px solid #ddd7ff", borderLeft: "6px solid #4f46e5", borderRadius: "12px", padding: "11px 10px", minHeight: "82px", background: "#ffffff", display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ width: "44px", height: "44px", borderRadius: "50%", background: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 900, fontSize: "22px", boxShadow: "0 6px 14px rgba(79,70,229,0.3)" }}>Σ</div>
              <div>
                <div style={{ fontSize: "14px", color: "#64748b", fontWeight: 800, letterSpacing: "0.8px" }}>TOPLAM</div>
                <div style={{ fontSize: "24px", color: "#0f172a", fontWeight: 900, lineHeight: 1, display: "flex", alignItems: "center", gap: "5px" }}>
                  {(nakitKasa + bankaBakiyesi + krediKartiBakiyesi).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  <span style={{ fontSize: "24px", fontWeight: 900, color: "#334155", alignSelf: "flex-start", marginTop: "1px" }}>₺</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mk-columns" style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          overflow: "hidden",
          boxSizing: "border-box",
          flex: 1,
          justifyContent: "center",
          minHeight: 0,
        }}>
          {categories.map((category) => {
            const width = categoryLayout[category.key] || { productWidth: "220px", totalWidth: "300px" };
            return (
              <div key={category.key} className="mk-col" data-kategori={category.key} style={{
                width: width.totalWidth,
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxSizing: "border-box",
                background: "#ffffff",
                border: "1px solid #dfe7f2",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(15, 23, 42, 0.05)",
              }}>
                <h3 style={{ fontSize: "12px", fontWeight: 800, margin: "0", padding: "5px 6px", color: "#334155", borderBottom: "1px solid #e5ebf3", background: "#f8fbff" }}>{category.name}</h3>
                <table className="mk-table" style={{
                  width: "100%",
                  borderCollapse: "separate",
                  borderSpacing: "0",
                  fontSize: "11px",
                  color: "#1f2937",
                  lineHeight: "1.2",
                  boxSizing: "border-box",
                  fontWeight: "700",
                }}>
                  <thead>
                    <tr>
                      <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 5px", width: width.productWidth, fontWeight: "800", fontSize: "11px", textAlign: "left", background: "#f3f7fd" }}>
                        Ürün
                      </th>
                      <th style={{ border: "1px solid #e5e7eb", borderBottom: "1px solid #c58a2f", padding: "4px 4px", width: "60px", fontWeight: "800", fontSize: "11px", textAlign: "center", background: "#f3f7fd" }}>
                        {category.fieldLabel}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.items.map((item) => {
                      const value = kasaData?.[category.key]?.[item.key]?.[category.field] || 0;
                      return (
                        <tr key={item.key}>
                          <td style={{
                            border: "1px solid #e5e7eb",
                            borderRight: "1px solid #e5e7eb",
                            padding: "5px 6px",
                            width: width.productWidth,
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                            boxSizing: "border-box",
                            fontWeight: 700,
                            fontSize: "14px",
                            color: "#0f172a",
                          }}>
                            {item.label}
                          </td>
                          <td style={{
                            border: "1px solid #e5e7eb",
                            borderRight: "1px solid #e5e7eb",
                            padding: "5px 4px",
                            width: "60px",
                            boxSizing: "border-box",
                            textAlign: "center",
                            fontSize: "15px",
                            fontWeight: 700,
                            color: value < 0 ? "#ef4444" : "#0f172a",
                            fontFamily: "Consolas, monospace",
                          }}>
                            {value.toLocaleString('tr-TR', {
                              minimumFractionDigits: (category.key === "hurda" || category.key === "doviz") ? 2 : 0,
                              maximumFractionDigits: 2
                            })}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })}
        </div>
      </div>
      <style>
        {`
        /* --- TELEFON (<=560px): kasa listesi tek ekrana yaklassin ---
           Satirlar sikisti; kisa isimli kategoriler (Gram Altin / Hurda /
           Doviz) iki sutuna dizildi. Sarrafiye isimleri uzun: tek sutun.
           Masaustu duzenine dokunulmaz. */
        @media (max-width: 560px) {
          .mk-page .mk-col h3 { position: sticky; top: 0; z-index: 2; padding: 6px 8px !important; font-size: 12.5px !important; }
          .mk-page .mk-table th, .mk-table td { padding: 2px 6px !important; font-size: 12px !important; }
          .mk-page .mk-col[data-kategori="sarrafiye"] .mk-table thead,
          .mk-page .mk-col[data-kategori="gramAltin"] .mk-table thead,
          .mk-page .mk-col[data-kategori="hurda"] .mk-table thead,
          .mk-page .mk-col[data-kategori="doviz"] .mk-table thead { display: none; }
          .mk-page .mk-col[data-kategori="sarrafiye"] .mk-table tbody,
          .mk-page .mk-col[data-kategori="gramAltin"] .mk-table tbody,
          .mk-page .mk-col[data-kategori="hurda"] .mk-table tbody,
          .mk-page .mk-col[data-kategori="doviz"] .mk-table tbody { display: grid; grid-template-columns: 1fr 1fr; column-gap: 6px; }
          .mk-page .mk-col[data-kategori="sarrafiye"] .mk-table tbody tr,
          .mk-page .mk-col[data-kategori="gramAltin"] .mk-table tbody tr,
          .mk-page .mk-col[data-kategori="hurda"] .mk-table tbody tr,
          .mk-page .mk-col[data-kategori="doviz"] .mk-table tbody tr { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; border-bottom: 1px solid #eef2f7; }
          .mk-page .mk-col[data-kategori="sarrafiye"] .mk-table tbody td,
          .mk-page .mk-col[data-kategori="gramAltin"] .mk-table tbody td,
          .mk-page .mk-col[data-kategori="hurda"] .mk-table tbody td,
          .mk-page .mk-col[data-kategori="doviz"] .mk-table tbody td { width: auto !important; min-width: 0 !important; border: none !important; padding: 2px 4px !important; font-size: 11px !important; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
        }

          .mk-table tbody tr:nth-child(odd) td {
            background: #fcfdff;
          }

          /* --- MOBİL: Mevcut Kasa (masaüstü inline stillere dokunulmaz) --- */
          /* Kompakt duzen: telefonlar + dokunmatik tabletler. Genis cok sutunlu
             yerlesim tablette 700px+ tasiyordu. 'any-pointer: coarse' sayesinde
             fare kullanan masaustu bu blogu hic okumaz. */
          @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
            .mk-page {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              margin: 0 !important;
              padding: 8px 4px 80px !important;
              overflow: visible !important;
              box-sizing: border-box !important;
              position: static !important;
            }

            .mk-header {
              display: flex !important;
              flex-direction: column !important;
              align-items: flex-start !important;
              gap: 4px !important;
              margin: 0 0 10px !important;
              padding: 0 2px 8px !important;
            }

            .mk-title {
              font-size: 17px !important;
            }

            .mk-date {
              font-size: 12px !important;
              line-height: 1.35 !important;
            }

            .mk-main-wrap {
              display: block !important;
              flex: none !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
            }

            .mk-sidebar {
              width: 100% !important;
              max-width: 100% !important;
              margin: 0 0 12px !important;
              padding: 10px !important;
              box-sizing: border-box !important;
            }

            .mk-summary-grid {
              display: grid !important;
              /* Tek sutunda her kartin sagi bostu; ikiserli diziliyor */
              grid-template-columns: 1fr 1fr !important;
              gap: 6px !important;
            }

            .mk-summary-grid > *:last-child {
              grid-column: 1 / -1 !important;
            }

            .mk-summary-card {
              min-height: 0 !important;
              padding: 10px !important;
              flex-direction: row !important;
              align-items: center !important;
              gap: 10px !important;
            }

            .mk-summary-card > div:first-child {
              width: 40px !important;
              height: 40px !important;
              font-size: 18px !important;
              flex-shrink: 0 !important;
            }

            .mk-summary-card > div:last-child > div:first-child {
              font-size: 12px !important;
            }

            .mk-summary-card > div:last-child > div:last-child {
              font-size: 20px !important;
            }

            .mk-summary-card > div:last-child > div:last-child span {
              font-size: 20px !important;
            }

            .mk-columns {
              display: block !important;
              flex: none !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              width: 100% !important;
            }

            .mk-col {
              display: block !important;
              width: 100% !important;
              max-width: 100% !important;
              height: auto !important;
              min-height: 0 !important;
              overflow: visible !important;
              margin: 0 0 12px !important;
              box-sizing: border-box !important;
            }

            .mk-col:last-child {
              margin-bottom: 0 !important;
            }

            .mk-col h3 {
              font-size: 13px !important;
              padding: 7px 8px !important;
            }

            .mk-table {
              display: table !important;
              width: 100% !important;
              table-layout: fixed !important;
              font-size: 12px !important;
            }

            .mk-table th,
            .mk-table td {
              padding: 6px 6px !important;
              width: auto !important;
              max-width: none !important;
            }

            .mk-table th:first-child,
            .mk-table td:first-child {
              width: auto !important;
            }

            .mk-table th:last-child,
            .mk-table td:last-child {
              width: 72px !important;
              min-width: 72px !important;
              max-width: 72px !important;
            }

            .mk-table td:first-child {
              font-size: 13px !important;
              line-height: 1.25 !important;
              word-break: break-word !important;
            }

            .mk-table td:last-child {
              font-size: 14px !important;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MevcutKasa;